import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useTasksFilter } from "@/contexts/TasksFilterContext";

export const TasksSearch = () => {
	const { t } = useTranslation();
	const { searchQuery, setSearchQuery } = useTasksFilter();

	return (
		<div className="relative flex-1">
			<Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
			<Input
				type="text"
				placeholder={t("tasks.filters.searchPlaceholder", "Search tasks...")}
				value={searchQuery}
				onChange={(e) => setSearchQuery(e.target.value)}
				className="pl-10"
			/>
		</div>
	);
};
